import { Component, Input, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import { firstValueFrom, Subscription } from 'rxjs';
import { CartService } from 'src/app/cart/cart.service';
import { AppState } from 'src/app/redux/app.state';
import { Product, ProductInCart, User } from 'src/typings';
import { ProductService } from '../product.service';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnDestroy {
  @Input() set products(products: Product[]) {
    this._products = products;
  }

  user: User | undefined;

  storeSubscription: Subscription;

  cartSubscription: Subscription;

  productSubscription: Subscription;

  constructor(
    private store: Store<AppState>,
    private cartService: CartService,
    private fb: FormBuilder,
    private productService: ProductService
  ) {
    this.productSubscription = this.productService.productGw.subscribe((list) => {
      this.updateProducts(list);
    });

    this.storeSubscription = this.store.subscribe((data) => {
      this.user = data.user.info;
      this.updateCartProducts();
    });
    this.cartSubscription = this.cartService.cartSocket.subscribe((cart) => {
      if (!this.user || !this.user.cart) return;
      if (cart.id === this.user.cart.id && cart.products) {
        this.cartProducts = cart.products.map((prod: any) => {
          return { ...prod, quan: Number(prod.quan) };
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.cartSubscription.unsubscribe();
    this.storeSubscription.unsubscribe();
    this.productSubscription.unsubscribe();
  }

  updateProducts(list: Product[]) {
    if (!list) return;
    for (let index = 0; index < list.length; index++) {
      const product = list[index];
      const foundIndex = this.products.findIndex((prod) => prod.id === product.id);
      this.products[foundIndex] = {
        ...this.products[foundIndex],
        ...product
      };
    }
  }

  get products() {
    return this._products;
  }

  set cartProducts(products: ProductInCart[]) {
    this._cartProducts = products;
    this.cartProductsFrom.clear();
    products.forEach((prod) => {
      this.cartProductsFrom.push(this.fb.group(prod));
    });
  }

  _cartProducts: ProductInCart[] = [];

  get cartProducts() {
    return this._cartProducts;
  }

  cartProductsFrom: FormArray = this.fb.array([]);

  private _products: Product[] = [];

  async updateCartProducts() {
    if (!this.user || !this.user.cart) return;
    const cart = await firstValueFrom(this.cartService.getOne(this.user.cart.id));
    if (cart.products) {
      this.cartProducts = cart.products.map((prod: any) => {
        return { ...prod, quan: Number(prod.quan) };
      });
    }
  }
}
